import { makeAutoObservable } from 'mobx';

/**
 * @implements {EN.Event}
 */
export class Event {
  /**
   * @param {EN.Event} model
   */
  constructor(model) {
    makeAutoObservable(this);

    /** @type {EN.Event['id']} */
    this.id = '';
    /** @type {EN.Event['lid']} */
    this.lid = '';
    /** @type {EN.Event['pid']} */
    this.pid = '';
    /** @type {EN.Event['slug']} */
    this.slug = '';
    /** @type {EN.Event['type']} */
    this.type = 0;
    /** @type {EN.Event['isUnsubscribed']} */
    this.isUnsubscribed = false;
    this.isBetBuilderSupported = false;

    Object.assign(this, model);
  }

  bestOf = null;

  competitors = [];

  mainMarketIds = [];

  marketIds = [];

  matchWinnerId = null;

  name = '';

  startTime = 0;

  status = 0;

  topIndex = null;

  willBeLive = null;

  hasVideo = false;

  /**
   * @deprecated Notes feature deleted from frontend.
   * Will be removed completely once backend removes notes support.
   */
  notes = [];

  hasScoreboard = false;

  update(data) {
    Object.assign(this, data);
  }
}
